<template>
    <div class="sideBar scrollbar_style" :class="{'cn':version==1}">
        <div class="sideBar_box">
            <div class="sideBar_ul">
                <div class="sideBar_li" @click="linkToFun('/dashboard')" :class="{'select':routerStr == '/dashboard'}">{{$t('App.sideBar.text1')}}</div>
                <div class="sideBar_li" @click="linkToFun('/room')" :class="{'select':routerStr == '/room'}">
                    <template v-if="domainName != 'uvlight'">
                        {{hotelType==1?$t('App.sideBar.text16'):$t('App.sideBar.text2')}}
                    </template>
                    <template v-if="domainName == 'uvlight'">
                        {{$t('App.sideBar.text19')}}
                    </template>
                </div>
                <div class="b_border"></div>
            </div>

            <div class="sideBar_ul">
                <div class="sideBar_li" v-if="hotelType==1" @click="linkToFun('/classroomLights')" :class="{'select':routerStr == '/classroomLights'}">{{$t('App.sideBar.text3')}}</div>
                <div class="sideBar_li" v-if="hotelType==1" @click="linkToFun('/blackboardLights')" :class="{'select':routerStr == '/blackboardLights'}">{{$t('App.sideBar.text4')}}</div>
                <div class="sideBar_li" v-if="hotelType==1" @click="linkToFun('/curtain')" :class="{'select':routerStr == '/curtain'}">{{$t('App.sideBar.text6')}}</div>
                <div class="sideBar_li" v-if="hotelType==1" @click="linkToFun('/switchPanel')" :class="{'select':routerStr == '/switchPanel'}">{{$t('App.sideBar.text5')}}</div>

                <div v-if="domainName != 'uvlight'" class="sideBar_li" @click="linkToFun('/lights')" :class="{'select':routerStr == '/lights'}">{{$t('App.sideBar.text7')}}</div>
                <div v-if="domainName != 'uvlight'&&domainName != 'plant'" class="sideBar_li" @click="linkToFun('/circadianLights')" :class="{'select':routerStr == '/circadianLights'}">{{$t('App.sideBar.text8')}}</div>
                <div v-if="domainName != 'uvlight'&&domainName == 'plant'" class="sideBar_li" @click="linkToFun('/circadianLights')" :class="{'select':routerStr == '/circadianLights'}">{{$t('App.sideBar.text24')}}</div>
                <div class="sideBar_li" @click="linkToFun('/sensor')" :class="{'select':routerStr == '/sensor'}">
                    <template v-if="domainName != 'uvlight'">
                        {{$t('App.sideBar.text15')}}
                    </template>

                    <template v-if="domainName == 'uvlight'">
                        {{$t('App.sideBar.text20')}}
                    </template>
                </div>
                <div class="sideBar_li" @click="linkToFun('/airPurifiers')" :class="{'select':routerStr == '/airPurifiers'}">{{$t('App.sideBar.text9')}}</div>

                <div v-if="domainName == 'room'||domainName == 'uvlight'" class="sideBar_li" @click="linkToFun('/uvLight')" :class="{'select':routerStr == '/uvLight'}">
                    <template v-if="domainName != 'uvlight'">
                        {{$t('App.sideBar.text18')}}
                    </template>
                    <template v-if="domainName == 'uvlight'">
                        {{$t('App.sideBar.text21')}}
                    </template>
                </div>

                <div class="sideBar_li" @click="linkToFun('/gateway')" :class="{'select':routerStr == '/gateway'}">{{$t('App.sideBar.text10')}}</div>
                <div class="sideBar_li" v-if="version==1" @click="linkToFun('/grouping')" :class="{'select':routerStr == '/grouping'}">{{$t('App.sideBar.text23')}}</div>
                
                <div class="b_border"></div>
            </div>

            <div class="sideBar_ul">
                <div class="sideBar_li" @click="linkToFun('/service')" :class="{'select':routerStr == '/service'}">{{$t('App.sideBar.text11')}}</div>
                <div class="sideBar_li" @click="linkToFun('/activityHistory')" :class="{'select':routerStr == '/activityHistory'}">{{$t('App.sideBar.text12')}}</div>
                <div class="sideBar_li" @click="linkToFun('/userManagement')" :class="{'select':routerStr == '/userManagement'}">{{$t('App.sideBar.text13')}}</div>
                <div class="sideBar_li" @click="linkToFun('/siteManagement')" :class="{'select':routerStr == '/siteManagement'}">
                    <template v-if="version == '0'&&domainName != 'uvlight'">{{$t('App.sideBar.text14')}}</template>
                    <template v-if="version == '1'&&domainName != 'uvlight'">{{$t('App.sideBar.text17')}}</template>

                    <template v-if="domainName == 'uvlight'">
                        {{$t('App.sideBar.text22')}}
                    </template>
                </div>
                <div class="b_border"></div>
            </div>
            <div class="login_box" v-if="version == '0'&&domainName != 'plant'">
                <img src="../img/svg/logo.svg">
            </div>
            <div class="login_box" style="height: 1rem;" v-if="domainName == 'plant'">
                <img src="../img/login/login_logo.png" v-if="domainName == 'plant'">
            </div>
            <!-- <div class="login_box" v-if="domainName == 'elinker'">
                <img src="../img/logo_yl.png">
            </div> -->
        </div>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from 'vuex'
    export default {
        name:'sideBar',
        data () {
            return {
                name:'',
            }
        },
        computed:{
            ...mapGetters({version:'version',routerStr:'routerStr',hotelType:'hotelType',domainName:'domainName'}),
        },
        mounted(){
        },
        methods:{
            linkToFun(val){
                if(val != this.routerStr){
                    this.$router.push({path:val});
                    this.$store.commit('ROUTERSTRFUN',{
                        routerStr:val,
                    })
                    // if(this.version == '0'){
                    //     document.title = 'inHealth-'+val.split('/')[1]
                    // }
                    // if(this.version == '1'){
                    //     document.title = '工业照明'
                    // }
                }
            }
        }
    } 
</script>

<style type="text/css" lang="less">
    .sideBar{
        position: fixed;
        top: 4.2rem;left:0;
        width: 12rem;
        min-width: 130px;
        height: calc(100% - 4.2rem);
        background: #FFFFFF;
        box-shadow: 0 0.2rem 1rem 0.6rem rgba(164,164,164,0.05);
        z-index: 2;
        // padding-bottom: 2rem;
        &.cn{
            .sideBar_ul{
                .sideBar_li{
                    &:hover{
                        color: #FFFFFF;
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    &.select{
                        color: #FFFFFF;
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    &.select::before {
                        background-color:rgba(255,255,255,0.3);
                    }
                }
            }
        }
        .sideBar_box{
            position: relative;
            height: 100%;
            min-height: 50rem;
        }
        .login_box{
            position: absolute;
            bottom: 0.83rem;
            // left:0.83rem;
            // width: 10rem;
            height: 2.42rem;
            width: 100%;
            text-align: center;
            img{
                max-width: 100%;
                // width: 100%;
                height: 100%;
            }
        }
        .sideBar_ul{
            padding: 1rem 0;
            width: 100%;
            .sideBar_li{
                padding-left: 1.5rem;
                height: 2.83rem;line-height: 2.83rem;
                font-family: AlibabaPuHuiTiR;
                font-size: 1rem;
                color: #333333;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                &:hover{
                    color: #FFFFFF;
                    background: rgba(5,207,171,0.6);
                }
                &.select{
                    color: #FFFFFF;
                    background: #05CFAB;
                    overflow: hidden;
                }
                &.select::after {
                    position: absolute;
                    display: block;
                    content: "";
                    top:0.9rem;left: 0;
                    width: 0.2rem;
                    height: 1rem;
                    background-color:#FFFFFF;
                }
                &.select::before {
                    position: absolute;
                    display: block;
                    content: "";
                    top:-8.4rem;right: -8.5rem;
                    width: 10rem;
                    height: 10rem;
                    background-color:#048F76;
                    transform: rotate(75deg) skew(60deg);
                }
            }
            .b_border{
                margin: 0 1.25rem 0 1.58rem;
                height: 0.05rem;
                background-color: rgba(198,205,213,0.3);
            }
        }
    }
</style>